<div class="btn-toolbar justify-content-center justify-content-md-end">
  <button type="button" class="btn btn-primary" (click)="cancelEvent.emit()">
    {{ "buttons.cancel" | msg | async }}
  </button>
  <button
    type="button"
    class="btn btn-danger ms-3"
    (click)="submitEvent.emit()"
    [disabled]="disabled"
  >
    {{ "buttons." + submitButtonText | msg | async }}
  </button>
</div>
